import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';

import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import "../Title/Title";

import template from './List.html?raw';

const domConstruct: any = domConstructTyped;

class List extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;
    onChange: any = function () { };
    onSelect: any = function () { };
    checkValidity: any = function () { return true };

    valid = false;
    mandatory = false;
    canSelect = true;
    canUnSelect = true;

    classNameInvalid = "invalidItem";
    classNameSelected = "selectedItem";

    nodeList: any = null;
    selectedKeys: any = null;

    keyArr: any = null;
    valuesList: any = null;
    dispnameList: any = null;

    selectionMode = "multi";

    isEnabledMultiSelection = true;

    getSelectedValues(): any {
        return {
            liList: this.nodeList,
            selectedKeys: this.selectedKeys
        };
    }

    constructor(params?: any) {
        super(...(arguments as unknown as []));
        lang.mixin(this, params);

        this.keyArr = [];
        this.keyArr.push("allIDs");
        this.keyArr.push("selectedIDs");

        this.valuesList = {};
        this.dispnameList = {};

        this.nodeList = new Map();
        this.selectedKeys = new Map();
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this._checkValidity();
    }




    clear(): void {
        domConstruct.empty(this.ul);
        this.nodeList.clear();
        this._onChange("allIDs");
        this.unSelect();
    }
    unSelect(): void {
        var selectedIDs = this.valuesList["selectedIDs"];
        selectedIDs.forEach(function (id) {
            //this.toogle(id);
            var item = this.nodeList.get(id);
            if (item) {
                domClass.remove(item.li, this.classNameSelected);
                //this.selectedKeys.delete(id);
                lang.hitch(this.selectedKeys, "delete")(id);
            }
        }, this);
        this.selectedKeys.clear();
        this._onChange("selectedIDs");
    }

    _onSelect(id: any): void {
        this.onSelect(id, this);
    }

    toogle(id: any): void {

        if (this.canSelect && this.nodeList.has(id)) {

            // wenn option "ich habe nichts gefunden" ist, soll sie exclusiv ausgewählt sein
            var exclusiveSelectionID = GP.ID_BOOKING_EXTERN_FREE_TEXT_EV_SERV.ID;
            var selectedIDs = this.valuesList["selectedIDs"];

            var item = this.nodeList.get(id);
            if (this.selectedKeys.has(id)) {
                lang.hitch(this.selectedKeys, "delete")(id);
                domClass.remove(item.li, this.classNameSelected);
                if (id == exclusiveSelectionID ) {
                    // element wird abgewählt
                    this.selectionMode = "multi";
                    this.emit("setSelectionModeOtherLists", this.selectionMode);
                }
            } else {
                // element ist nicht ausgewählt - auswählen

                this.selectedKeys.set(id, item);
                domClass.add(item.li, this.classNameSelected);

                if (id == exclusiveSelectionID) {
                    this.selectionMode = "single";
                    this.emit("setSelectionModeOtherLists", this.selectionMode);
                }
            }

            if (this.selectionMode == "single") {
                //  andere items innerhalb einer liste unSelectieren damit immer nur das letzte item selected ist
                selectedIDs.forEach(function (selectedId) {
                    if (selectedId != id) {
                        var item = this.nodeList.get(selectedId);
                        domClass.remove(item.li, this.classNameSelected);
                        //this.selectedKeys.delete(selectedId);
                        lang.hitch(this.selectedKeys, "delete")(selectedId);
                    }
                }, this);

                // andere Lists des GroupedListDialogs unSelectieren
                //
                this.emit("unselectOtherLists", this);

                ////// element ist nicht exclusive und zuvor war das exclusive element ausgewählt
                if (exclusiveSelectionID && id != exclusiveSelectionID && this.isEnabledMultiSelection) {

                    this.selectionMode = "multi";
                    this.emit("setSelectionModeOtherLists", this.selectionMode);
                }
            }

        } else if (this.canUnSelect) {

            var item = this.nodeList.get(id);
            if (this.selectedKeys.has(id)) {
                //this.selectedKeys.delete(id);
                lang.hitch(this.selectedKeys, "delete")(id);
                domClass.remove(item.li, this.classNameSelected);
            }
        }

        this._onSelect(id);
        this._onChange("selectedIDs");
    }

    _onChange(key: any): void {
        this._updateKeyCache(key);
        this._checkValidity();
        this.onChange(key, this);
        this.emit("change", this.get("SelectedIDs"));
    }
    _updateKeyCache(key: any): void {
        this.valuesList[key] = this.get(key);
        this.dispnameList[key] = this._getDispName(key);
    }

    _checkValidity(): any {
        var valid = true;

        this.keyArr.forEach(function (key) {
            if (this._checkKeyValidity(key) === false) valid = false;
        }, this);
        this.valid = valid;

        this._showValidState();
        return valid;
    }
    _checkKeyValidity(key: any): any {
        if (this.valuesList[key] == undefined) this.valuesList[key] = this.get(key);
        if (this.dispnameList[key] == undefined) this.dispnameList[key] = this._getDispName(key);

        var valid = true;
        switch (key) {
            case "allIDs":
                if ((this.canSelect && this.get(key).length > 0) || (!this.canSelect && this.nodeList.size > 0)) {
                    valid = this.checkValidity(key, this);
                } else {
                    valid = false;
                }
                break;
            case "selectedIDs":
                if ((this.canSelect && this.get(key).length > 0) || (!this.canSelect && this.nodeList.size > 0) ) {
                    valid = this.checkValidity(key, this);
                } else {
                    valid = false;
                }
                break;
        }
        return valid;
    }
    _showValidState(): void {
        var condition = (this.mandatory === false) ? false : !this.valid;
        domClass.toggle(this.ul, this.classNameInvalid, condition);
    }
    _getSelectedIDsAttr(): any {
        var selectedIDs = [];

        this.selectedKeys.forEach(function (item, id) {
            selectedIDs.push(id);
        }, this);
        return selectedIDs;
    }
    _getAllIDsAttr(): any {
        var allIDs = [];

        this.nodeList.forEach(function (item, id) {
            allIDs.push(id);
        }, this);
        return allIDs;
    }
    _getDispName(key: any): any {
        switch (key) {
            case "selectedIDs":
                var selectedDispNames = [];
                this.selectedKeys.forEach(function (node) {
                    selectedDispNames.push(node.div.innerText);
                }, this);
                var dispName: any = {
                    value: selectedDispNames
                }
                break;
            case "allIDs":
                var itemDispNames: any = [];
                this.nodeList.forEach(function (node) {
                    itemDispNames.push(node.div.innerText);
                }, this);
                var dispName: any = {
                    value: itemDispNames.div
                }
                break;
        }
        return dispName;
    }


    _setSelectedIDsAttr(selectedItemsList: any): any {
        selectedItemsList.forEach(function (id) {
            if (this.selectedKeys.has(id) === false) this.toogle(id);
        }, this);
        return this;
    }
    _setItemListAttr(itemsList: any): any {
        itemsList.forEach(function (item) {
            this.add(item.id, item.div, item.canRemove);
        }, this);
        return this;
    }
    add(id: any, div: any, canRemove: any): void {
        var label;

        if (div instanceof HTMLElement) {
            label = div.innerText;
        } else {
            // div ist ein object das domNode und text beinhaltet
            label = div.label;
            div = div.node;
        }

        if (this.nodeList.has(id) === false) {
            var li = domConstruct.create("li", { className: "w3-button", style: "width: 100%; overflow: visible;" }, this.ul);
            on(li, "click", lang.hitch(this, "toogle", id));
            this.nodeList.set(id, { li: li, div: div, label: label });

            domConstruct.place(div, li);
            domStyle.set(div, "float", "left");

            if (canRemove) {
                var i = domConstruct.create("i", { className: "fa fa-remove", style: "float: right;" }, li);
                on(i, "click", lang.hitch(this, "remove", id));
            }
            this._onChange("allIDs");
        }
    }

    remove(id: any): void {
        if (this.nodeList.has(id)) {
            domConstruct.destroy(this.nodeList.get(id).li);
            //this.nodeList.delete(id);
            lang.hitch(this.nodeList, "delete")(id);
            this._onChange("allIDs");
        }
    }
}
List.prototype.declaredClass = 'more.Legacy.Zal.List';

export default mdsWidget(List);
